import script from "./DateRangeField.vue?vue&type=script&setup=true&lang=js"
export * from "./DateRangeField.vue?vue&type=script&setup=true&lang=js"

import "./DateRangeField.vue?vue&type=style&index=0&id=2203f981&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2203f981"]])

export default __exports__